// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__TpWdd","active":"NavigationItem_active__2A6zN"};